import React from 'react';
import './contact.css';


class Contact extends React.Component{



     validate() { 
        var subject = document.getElementById("subject").value;
        var message = document.getElementById("message").value;
        var status = document.getElementById("status");
        status.style.color = 'red';
        if(subject === ''){
            status.innerHTML = 'Fill in the fiel Subject';
        }else if(message === ''){
            status.innerHTML = 'Fill in the fiel Message';
        }
        else{
            var boutonSubmit = document.getElementById("btt");
            boutonSubmit.addEventListener('click', function(){
            var send = document.getElementById('send');
            send.href = 'mailto:jansel.services@gmail.com?subject='+subject+'&body='+message+' ';
           })
        }
       
        
       

}

    render(){
        return(
            <div className="container " id="contact">
               <section class="mb-4">


<h2 class="h1-responsive font-weight-bold text-center my-4" >Contact Us &nbsp; 
<a class="btn btn-success" href="mailto:jasnel.services.@gmail.com" id="send"><i className="fa fa-envelope"></i> Send Message</a>
</h2>



<div class="row">

    
    {/* <div class="col-md-12 mb-md-0 mb-5">
        <form id="contact-form" name="contact-form"  action="" method="get">           
            <div class="row">
                <div class="col-md-12">
                    <div class="md-form mb-0">
                        <input type="text" id="subject" name="subject" class="form-control" required/>
                        <label for="subject" class="">Subject</label>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-md-12">
                    <div class="md-form mb-0">
                        <input type="text" id="message" name="message" class="form-control" required/>
                        <label for="subject" class="">message</label>
                    </div>
                </div>
            </div>
        </form>

        <div class="text-center text-md-left" id="btt" onClick={this.validate}>
            <a class="btn btn-success" id="send"><i className="fa fa-envelope"></i> Send Message</a>
            
        </div>
        <div id="status"></div>
    </div> */}
 
 
           
        
    

</div>

</section>
                
            </div>
        )
    }
}
        
    

export default Contact;
